"use strict";
import React from "react";
import { RX } from '../authentication/constants';

const initComponent = (flex = window.flex) => {

    class DevPanel extends React.PureComponent {
        state = { isVisible: flex.getCookie("flex-dev") };

        componentDidUpdate() {
            const state = this.state || {};
            if (state.isVisible) $("body").css("margin-top", $("#dev-panel").height());
            else $("body").css("margin-top", 0);
        }

        componentDidMount() {
            const state = this.state || {};
            if (state.isVisible) $("body").css("margin-top", $("#dev-panel").height());
            else $("body").css("margin-top", 0);

            if (state.isVisible) {
                flex.trigger(RX.DISPLAY_TOKENS);
            }
        }

        handleToggle = () => {
            const state = this.state || {};
            const isVisible = !state.isVisible;
            this.setState({ isVisible: isVisible });
            if (isVisible)
                flex.setCookie({ key: "flex-dev", value: "1" });
            else {
                //me.devPanel = false;
                flex.removeCookie("flex-dev");
                flex.removeCookie("flex-host");
                flex.removeCookie("flex-su");
                flex.removeCookie("flex-show-local");
                flex.removeCookie("flex-locale")
            }
        };

        setHost = () => {
            const host = $("#dev-host").val().trim();
            if (host) flex.setCookie({ key: "flex-host", value: host });
            else flex.removeCookie("flex-host");
            flex.redirect();
        };

        setSuper = () => {
            const devSuper = $("#dev-super").is(':checked');
            if (devSuper) flex.setCookie({ key: "flex-su", value: 1 });
            else flex.removeCookie("flex-su");
            flex.redirect();
        };

        setShowLocal = () => {
            const devShowLocal = $("#dev-show-local").is(':checked');
            if (devShowLocal) flex.setCookie({ key: "flex-show-local", value: 1 });
            else flex.removeCookie("flex-show-local");
            flex.redirect();
        };

        downloadStore = () => {
            var element = document.createElement('a');
            const store = flex.getStore();
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(store, null, 2)));
            element.setAttribute('download', "store.json");

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        };

        downloadLocalText = () => {
            var element = document.createElement('a');
            const store = flex.getStore();
            element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(JSON.stringify(store.localText, null, 2)));
            element.setAttribute('download', "localtext-" + flex.getCookie("flex-locale") + ".json");

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        };

        setLocale = () => {
            const store = flex.getStore();
            var newLocale = $("#dev-locale").val().trim();
            flex.setCookie({ key: "flex-locale", value: newLocale });
            var newLocalTextPath = store.appContext.localTextPath.replace("en-US", newLocale);
            flex.trigger("global:localText-get", { path: newLocalTextPath });
        };

        handleBuyerauth = () => {
            console.log("BUYER AUTH")
            flex.trigger("global:handle-buyer-auth");
        };

        runAuthenticationFlow = () => {
            flex.trigger(RX.RUN_AUTHORIZATION_CODE_FLOW);
        };

        render() {
            const state = this.state || {};
            const hostHeader = flex.getCookie("flex-host") || "";
            const devSuper = flex.getCookie("flex-su") || false;
            const devShowLocal = flex.getCookie("flex-show-local") || false;
            const devLocale = flex.getCookie("flex-locale") || "en-US";
            if (!state.isVisible) return <div className="dev-toggle" onClick={this.handleToggle}></div>;
            else return (
                <div id="dev-panel" className="print-hidden">
                    <div className="dev-toggle" onClick={this.handleToggle}></div>

                    <div className="dev-panel-item">
                        <div className="input-group">
                            <input type="text" id="dev-host" name="dev-host" className="form-control" defaultValue={hostHeader} placeholder="no host header" />
                            <span className="input-group-btn">
                                <button className="btn btn-secondary" type="button" onClick={this.setHost}>Go!</button>
                            </span>
                        </div>
                    </div>
                    <div className="dev-panel-item">
                        <label className="checkbox-inline" style={{ margin: "5px" }}><input type="checkbox" id="dev-super" name="dev-super" onClick={this.setSuper} defaultChecked={devSuper} /><span>super</span></label>
                    </div>
                    <div className="dev-panel-item">
                        <label className="checkbox-inline" style={{ margin: "5px" }}><input type="checkbox" id="dev-show-local" name="dev-show-local" onClick={this.setShowLocal} defaultChecked={devShowLocal} /><span>show local</span></label>
                    </div>
                    <div className="dev-panel-item">
                        <div className="input-group">
                            <input type="text" id="dev-locale" name="dev-locale" className="form-control" defaultValue={devLocale} />
                            <span className="input-group-btn">
                                <button className="btn btn-secondary" type="button" onClick={this.setLocale}>Travel!</button>
                            </span>
                        </div>
                    </div>
                    <div className="dev-panel-item">
                        <span style={{ display: "inline-block", margin: "5px", padding: "4px" }} onClick={this.downloadStore} className="btn btn-secondary">Download Store</span>
                    </div>
                    <div className="dev-panel-item">
                        <span style={{ display: "inline-block", margin: "5px", padding: "4px" }} onClick={this.downloadLocalText} className="btn btn-secondary">Download Localization Dict</span>
                    </div>
                    <div className="dev-panel-item">
                        <button className="btn btn-secondary" type="button" onClick={this.handleBuyerauth}>Buyer Auth</button>
                    </div>
                    <div className="dev-panel-item">
                        <a href="/ops" style={{ display: "inline-block", margin: "5px", padding: "4px" }} className="btn btn-secondary">Ops</a>
                    </div>
                    <div className="dev-panel-item">
                        <span style={{ display: "inline-block", margin: "5px", padding: "4px" }} onClick={this.runAuthenticationFlow} className="btn btn-secondary">Run Authentication Flow</span>
                    </div>
                </div>
            );
        }
    }

    return DevPanel;
};

module.exports = initComponent;
